export default defineAppConfig({
  title: "Happy box",
  theme: {
    colors: {
      primary: "#e72b6f",
    },
  },
});
